import { render } from "./AppPage.vue?vue&type=template&id=3a97b882"
import script from "./AppPage.vue?vue&type=script&lang=js"
export * from "./AppPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/nikita/Documents/works/novosel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__